
export const AdStrategyEnum = {
  status: {
    template: {
      ENABLE: 0,
      PAUSE: 1,
      ARCHIVE: 2
    },
    object: {
      ENABLE: 0,
      PAUSE: 1,
    }
  },
  statusOption: {
    object: [
      {id: 0, text: '启用'},
      {id: 1, text: '暂停'},
    ]
  },
  opTypeOption: [
    {id: 1, text: '基础调整竞价'},
    {id: 0, text: '基础调整预算'},
    {id: 3, text: '分时调整竞价'},
    {id: 2, text: '分时调整预算'},
    {id: 5, text: '模板调整竞价'},
    {id: 4, text: '模板调整预算'},
    {id: 6, text: '新增策略'},
    {id: 7, text: '修改策略'},
    {id: 8, text: '删除策略'},
    {id: 9, text: '分时恢复基础价格'},
  ],
  adjustType: {
    bid: 0,
    budget: 1,
    placementBid: 2
  },
  adjustTypeOption: [
    {id: 0, text: '调整竞价'},
    {id: 1, text: '调整每日预算'},
    {id: 2, text: '调整广告位竞价'},
  ],
  triggerType: {
    time: 0
  },
  triggerTypeOption: [
    {id: 0, text: '按时间'},
  ],
  timeOption: {
    start: '00:00',
    step: '01:00',
    end: '24:00'
  },
  repeatOption: [
    {id: 0, text: '每天'},
    {id: 7, text: '周日'},
    {id: 1, text: '周一'},
    {id: 2, text: '周二'},
    {id: 3, text: '周三'},
    {id: 4, text: '周四'},
    {id: 5, text: '周五'},
    {id: 6, text: '周六'},
  ],
  bidForm: {
    adjustType: {
      PERCENT_ADD: 0,
      PERCENT_SUB: 1,
    },
    adjustTypeOption: [
      {id: 0, text: '增加%'},
      {id: 1, text: '减少%'},
    ]
  },
  budgetForm: {
    adjustType: {
      PERCENT_ADD: 0,
      VALUE_ADD: 2,
    },
    adjustTypeOption: [
      {id: 0, text: '增加%'},
      {id: 2, text: '增加'},
    ]
  },
  placementBidForm: {
    adjustType: {
      PERCENT_ADD: 0,
      PERCENT_SUB: 1,
      VALUE_ADD: 2,
      VALUE_SUB: 3,
    },
    adjustTypeOption: [
      {id: 0, text: '增加%'},
      {id: 1, text: '减少%'},
      {id: 2, text: '增加'},
      {id: 3, text: '减少'},
    ]
  },
  adjustForm:{
    adjustType:{
      PERCENT_ADD: 0,
      PERCENT_SUB: 1,
      VALUE_ADD: 2,
      VALUE_SUB: 3,
      VALUE_FIXED: 4
    },
    adjustTypeOption:[
      {id: 0, text: '提高（%）'},
      {id: 1, text: '降低（%）'},
      {id: 2, text: '提高（数值）'},
      {id: 3, text: '降低（数值）'},
      {id: 4, text: '直接设置为'},
    ],
  },

  objectType: {
    CAMPAIGN: 0,
    GROUP: 1,
    PLACEMENT: 2,
    KEYWORD: 3,
    PRODUCT_TARGET: 4,
    TARGET_GROUP: 5,
  },
  objectTypeOption: [
    {id: 0, text: '广告活动'},
    {id: 1, text: '广告组'},
    {id: 2, text: '广告位'},
    {id: 3, text: '关键词'},
    {id: 4, text: '商品投放'},
    {id: 5, text: '投放组'},
  ],
  templateType: {
    PUBLIC: 0,
    PRIVATE: 1,
    TEMPORARY: 2
  },
  //广告状态
  adStatusOption: [
    {id: 0, text: '活跃'},
    {id: 1, text: '不活跃'},
  ],
  //策略状态
  policyStatusOption: [
    {id: 0, text: '开启中'},
    {id: 1, text: '暂停中'},
  ],
  // 分时策略模板 结果通知 下拉框选项
  resultOption:[
    {id:2,text:'有错误时通知'},
    {id:1,text:'执行完成通知'},
    {id:0,text:'不通知'},
  ],
  //自动规则操作对象类型
  executeObjectTypeOption: [
    {
      id: 'campaign',
      text: '广告活动',
    },
    {
      id: 'group',
      text: '广告组',
    },
    {
      id: 'keyword',
      text: '关键词',
    },
    {
      id: 'manualTarget',
      text: '商品投放',
    },
    {
      id: 'autoTarget',
      text: '投放组',
    },
    {
      id: 'asinSearch',
      text: '搜索词-asin',
    },
    {
      id: 'keywordSearch',
      text: '搜索词-关键词',
    },
  ],
  //通过操作对象ID取内容
  getObjectTypeText: {
    campaign: '广告活动',
    group: '广告组',
    keyword: '关键词',
    manualTarget: '商品投放',
    autoTarget: '投放组',
    asinSearch: '搜索词-asin',
    keywordSearch: '搜索词-关键词'
  },
  //自动规则操作类型
  operationTypeOption: [
    {
      id: 'addRule',
      text: '新增规则',
    },
    {
      id: 'updateRule',
      text: '更换规则',
    },
    {
      id: 'updateState',
      text: '修改状态',
    },
    {
      id: 'target',
      text: '添加投放',
    },
    {
      id: 'negativeTarget',
      text: '添加否定投放',
    },
    {
      id: 'parseTarget',
      text: '暂停',
    },
    {
      id: 'adjustBudget',
      text: '调整预算',
    },
    {
      id: 'adjustBid',
      text: '调整竞价',
    },
  ],

};























